import React from 'react';
import { Box } from '@nimbus-ds/components';
import AppLayout from 'App/components/AppLayout';
import { ErrorMessage } from 'commons/components';
import { useTranslationWithPrefix } from 'commons/utils';

function ProofOfLifeError(): JSX.Element {
  const { t } = useTranslationWithPrefix('identityValidation');

  return (
    <AppLayout title={t('proofOfLife.title')}>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        gap="4"
      >
        <ErrorMessage />
      </Box>
    </AppLayout>
  );
}

export default ProofOfLifeError;
